import {uniqid} from 'uniqid';

/**
 * @param length
 * @returns {string}
 */
export const uniqueID = () => {
    let result           = '';
    const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    const length = 16;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const gen_uid = () => {
    const uniueid = uniqid('client_');
    // console.log('generated using gen_uid ' + uniueid);
    return uniueid;
}

/**
 * Escape a value for safe interpolation into an HTML string (text content or
 * a quoted attribute value).
 *
 * CVE fix (Aikido): "Unsanitized user input in jQuery DOM handling methods" /
 * "Using document write methods can lead to XSS attacks" - several places
 * build HTML via string concatenation or template literals and assign it to
 * innerHTML. Wrap any dynamic value going into one of those strings with
 * this before interpolating it.
 *
 * @param value
 * @returns {string}
 */
export const escapeHtml = value => {
    return String(value === undefined || value === null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}
